<template>
    <div id="css">
        <b-row class="backInfoMain2">

            <s-menuSave :msg="sendMsg"></s-menuSave>

            <!--Section de gauche-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                <div>
                    <!--Affichage de la liste-->
                    <b-row>
                        <s-itemList 
                            v-if="fromApi"
                            style="width: 100%" 
                            :content="fromApi" 
                            :returnValue.sync="activeObj" 
                            showField="name" 
                            activeField="active"
                            :selectedItems="activeObj"
                            firstLetterNotUpper>
                        </s-itemList>
                    </b-row>                            
                </div>
            </b-col>
            <!--Fin section de gauche-->

<!--****************************************************************************************************************************************************************-->
            
            <!--Section de droite-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="pSize.right.xl">

                <span v-if="activeObj.componentsType == ''">
                    <b-row>
                        <!--<b-col cols="3" class="docCellL docTitre">{{fromApi[activeObj.id].name}}</b-col>-->
                        <b-col cols="3" class="docCellL docTitre">Nom de la class</b-col>
                        <b-col cols="3" class="docCellC docTitre">Nom du fichier</b-col>
                        <b-col cols="5" class="docCellR docTitre">Exemple</b-col>
                    </b-row>

                    <span v-for="(item) in allData[activeObj.list]" :key="item.index"> 
                            <b-row>
                                <!--symbol-->
                                <template v-if="item.symbol == '' || item.symbol == null">
                                    <!--<b-col cols="3" style="white-space:pre-wrap;" class="subDocCellL" v-b-popover.hover.left="item.code"  :title="item.name">
                                        .{{item.name}}
                                    </b-col>-->
                                    <b-col cols="3" class="subDocCellL">.{{item.name}}</b-col>
                                </template>
                                <template v-else>
                                    <b-col cols="3" class="subDocCellL">{{item.symbol}}{{item.name}}</b-col>
                                </template>

                                <b-col cols="3" class="subDocCellC">{{item.file}}</b-col>
                                <b-col cols="5" :style="item.style" class="subDocCellR">
                                    <span :class="item.name">{{item.text}}</span>
                                </b-col>
                            </b-row>
                            <!--description-->
                            <b-row v-if="item.description != ''">
                                <b-col class="docDescription" cols="11">
                                    <span style="">{{item.description}}</span>
                                </b-col>
                            </b-row>
                    </span>
                </span>

                <span v-if="activeObj.componentsType == 'combinaison'"><combinaison></combinaison></span>
                <span v-if="activeObj.componentsType == 'controls'"><controls></controls></span>

                <br><br><br><br><br><br><br><br>

            </b-col>
            <!--FIN - Section de droite-->

            <br><br>
            
        </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'

import css_mixin from './css_mixin'
//import axios from 'axios';

import combinaison from './components/combinaison/combinaison.vue'
import controls from './components/controls/controls.vue'

export default{
    name: "css",
    mixins:[css_mixin],
    components: {
        combinaison,
        controls
    },
    data() {
        return{
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            chkSize: this.$store.getters.getCheckSize,
            sendMsg: '', //message a utiliser pour le menu en haut de la page New/Save/Delete
            output: 'null', //Message de reception de l'API
            error: null, //Message d'erreur de l'API
            startModule: 0,
            selectedCSS: 0,
            fromApi: [
                {
                    id: 0,
                    active: true,
                    name: 'Titre et sous-titre',
                    list: 'titreSousTitre',
                    description: '',
                    componentsType: ''
                },
                {
                    id: 1,
                    active: true,
                    name: 'Texte',
                    list: 'texte',
                    description: '',
                    componentsType: '' 
                },
                {
                    id: 2,
                    active: true,
                    name: 'Text style',
                    list: 'style',
                    description: '',
                    componentsType: '' 
                },
                {
                    id: 8,
                    active: true,
                    name: 'Police',
                    list: 'police',
                    description: '',
                    componentsType: '' 
                },
                {
                    id: 9,
                    active: true,
                    name: 'Police Taille',
                    list: 'policeTaille',
                    description: '',
                    componentsType: '' 
                },
                {
                    id: 3,
                    active: true,
                    name: 'Containers',
                    list: 'containers',
                    description: '',
                    componentsType: '' 
                },
                {
                    id: 4,
                    active: true,
                    name: 'Separateur',
                    list: 'separateur',
                    description: '',
                    componentsType: '' 
                },
                {
                    id: 5,
                    active: true,
                    name: 'Couleur',
                    list: 'color',
                    description: '',
                    componentsType: '' 
                },
                {
                    id: 6,
                    active: true,
                    name: 'CSS Combinaison',
                    list: 'combin',
                    description: '',
                    componentsType: 'combinaison' 
                },
                {
                    id: 7,
                    active: true,
                    name: 'Controls',
                    list: 'controls',
                    description: '',
                    componentsType: 'controls' 
                }

            ], //Contenu de l'API
            InitialState: null, //Format initial de : activeObj
            //Objet en cours de modification
            activeObj:{

            },

        }
    },
    methods: {
        
    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getTheme', 'getApiAdress', 'getApiAdd', 'getPageSize', 'getworkLicence', 'getApiKey', 'getCombo', 'getCheckSize']),
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.activeObj = this.$CObj(this.fromApi[this.startModule])
    },
//------------------------------------------------------------------------------------------------
    watch: {

    }
}
</script>

<style lang="scss" scoped>
@import './css.scss';
@import './css_color_doc.scss';
</style>